import { useQuery } from '@tanstack/react-query';

import { useCurrentUserQuery } from '@/shared/legacy/hooks/useCurrentUserQuery';
import { QueryKey } from '@/types/query';
import { nylasCalendarManageConnectionModalClient } from './client';

export const useGetNylasOauthUrlQuery = () => {
  const { data: currentUser } = useCurrentUserQuery();

  return useQuery({
    queryKey: [QueryKey.useGetNylasOauthUrlQuery, currentUser?.email],
    queryFn: async () => {
      const { data } = await nylasCalendarManageConnectionModalClient.getNylasOauthUrl();

      return data;
    },
  });
};
